export default __webpack_public_path__ + "static/media/meta-shadow.122926ea.svg";